<template>
<div class="chapter">
<div class="inner_page">
<p class="block_15"> </p>
<p class="block_11"><i class="calibre1">History is a set of lies agreed upon.<br class="calibre4"/></i><span class="text_1"> – Napoléon Bonaparte</span></p>
<p class="block_15"> </p>
<p class="block_15"> </p>
<p class="block_16">Man is not what he thinks he is. He is what he hides. </p>
<p class="block_13">– André Malraux<br class="calibre4"/> </p>
<p class="block_17" id="calibre_pb_6"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_006.vue?49998618